"use strict";

var Immutable = require('immutable');

var moment = require('ofs/moment');

var React = require('react');
var ReactForms = require('react-forms');

var i18n = require('ofs/i18n');
var gettext = i18n.gettext;

var Scalar = require('ofs/forms/scalars/Scalar');
var TimeScalar = require('ofs/forms/scalars/TimeScalar');

var SelectOne = require('ofs/forms/inputs/simple-choice');

var FormElement = ReactForms.Element;
var Row = require('ofs/forms/layout/row');
var Column = require('ofs/forms/layout/column');

var timezones = require('ofs/utils/timezones');
var timezoneOptions = Immutable.fromJS(timezones).map(function(v) { return { value: v.get(0), name: v.get(1)}; }).toJS();

var InternationalPhoneInput = require('ofs/forms/inputs/international-phone-input');

var messages = {
  PHONE_NUMBER_LABEL: gettext('Phone number'),
  TIMEZONE_LABEL: gettext('Your timezone'),
  PREFER_CALL_TIME_LABEL: gettext('I prefer to be called at this time')
};


var mapping = function() {
  return {
    phone_number: Scalar({
      label: messages.PHONE_NUMBER_LABEL,
      input: <InternationalPhoneInput />,
      required: true
    }),
    timezone: Scalar({
      label: messages.TIMEZONE_LABEL,
      defaultValue: moment().format('ZZ'),
      input: <SelectOne options={timezoneOptions} />,
      required: true
    }),
    prefer_call_time: Scalar({
      type: 'bool',
      label: messages.PREFER_CALL_TIME_LABEL
    }),
    call_time: TimeScalar({
      label: null
    })
  };
};

var layout = function(value) {
  return [
    <Row>
      <Column size="full"><FormElement value={value.get('phone_number')} /></Column>
    </Row>,
    <Row>
      <Column size="full"><FormElement className="bdd-enquire-modal-field-timezone" value={value.get('timezone')} /></Column>
    </Row>,
    <Row>
      <Column size="half"><FormElement className="bdd-enquire-modal-field-calltime" value={value.get('call_time')} /></Column>
      <Column size="half"><FormElement className="bdd-enquire-modal-field-calltime-prefer" value={value.get('prefer_call_time')} /></Column>
    </Row>
  ];
};

module.exports = {mapping, layout};





/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/mappings/telephone.jsx
 **/